import { render } from "./permisos.vue?vue&type=template&id=1b85d289&scoped=true"
import script from "./permisos.vue?vue&type=script&lang=js"
export * from "./permisos.vue?vue&type=script&lang=js"

import "./permisos.vue?vue&type=style&index=0&id=1b85d289&lang=css"
import "./permisos.vue?vue&type=style&index=1&id=1b85d289&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b85d289"]])

export default __exports__